import { Link, useParams } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { useMeetingDetail } from '../../../queries/meetings';
import { formatDateLocal } from '../meetings-helpers';
import { RaceDrillDownContent } from './RaceDrillDownContent';
import { Button } from '../../../components/ui/Button';

export function RaceDrillDownPage() {
  const { meetingId = '' } = useParams<{ meetingId: string }>();
  const { data: meeting, isLoading: meetingLoading } = useMeetingDetail(meetingId);
  const meetingDate = meeting?.meeting_date ? formatDateLocal(new Date(meeting.meeting_date)) : '';

  return (
    <div className="space-y-6">
      <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:gap-4">
        <Button asChild variant="outline" size="sm" className="self-start">
          <Link to="/meetings">
            <ChevronLeft className="h-4 w-4" />
            Back to Meetings
          </Link>
        </Button>
        <div className="min-w-0">
          <h1 className="text-xl font-bold tracking-tight sm:text-2xl">Races</h1>
          {!meetingLoading && meeting && (
            <p className="mt-0.5 truncate text-sm text-muted-foreground">
              {meeting.track.name} &middot; {meetingDate}
            </p>
          )}
        </div>
      </div>

      <RaceDrillDownContent meetingId={meetingId} />
    </div>
  );
}
